import { useRoutes } from 'react-router-dom';
import MainRoutes from './mainRoutes';
import AuthenticationRoutes from './authenticationRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    let rotas = [MainRoutes, AuthenticationRoutes];
    return useRoutes(rotas);
}
